export const getCaretIconEncodedUrl = (fill: string) =>
  `data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4 6L8 10L12 6' stroke='${encodeURIComponent(
    fill,
  )}' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A`;
